export enum APIErrorMessage {
  InsufficientScope = 'insufficient scope for this resource',
}
